module.exports = __webpack_public_path__ + "img/camera_icon.75155eed.svg";